import { get, post } from './request'

// 获取活动样式配置
export const getRankConfig = (data) => {
  return get('/question_active/rank_setting', data)
}

// 获取白名单配置
export const getWhiteList = (data) => {
  return get('/question_active/check_white', data)
}

// 获取一级排名
export const getFirstRank = (data) => {
  return get('/question_active/list_first', data)
}

// 获取个人排名
export const getPersonRank = (data) => {
  return get('/question_active/level_rank_user', data)
}

// 获取团体排名
export const getGroupRank = (data) => {
  return get('/question_active/level_rank', data)
}

// 学习增加积分
export const addPointByStudy = (data) => {
  return post('/question_active/score_study', data)
}
